import React from 'react';
import './App.css';
import Header from './components/Header';
import Intro from './components/Intro';
import About from './components/About';
import Main from './components/Main';
import Footer from './components/Footer';

class App extends React.Component {
	render() {
		return (
			<>
				<Header />
				<Intro />
				<About />
				<Main />
				<Footer />
			</>
		);
	}
}
export default App;
